import { render, staticRenderFns } from "./modal-sip-edit-form.vue?vue&type=template&id=2df0bb74&"
import script from "./modal-sip-edit-form.vue?vue&type=script&lang=js&"
export * from "./modal-sip-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports